import { BRAND_OFFERS_PAGE_PATH } from '../BrandOffersPage/BrandOffersPage.constants';

/** Back link target — same route as the offer desk. */
export const BRAND_DETAILS_BACK_TO = BRAND_OFFERS_PAGE_PATH;

export const BRAND_DETAILS_COPY = {
  backLink: 'Back to offers',
  idLabel: 'Admin',
  typeBadge: 'Brand Directory',
  statusLive: 'Live',
  title: 'Brand Details',
  subtitle: 'Browse all brands mapped for offer management.',
  overviewSection: 'Overview',
  totalBrandsLabel: 'Total Brands',
  listSection: 'Brand List',
  loadingBrands: 'Loading brands...',
  loadError: 'Could not load brands. Check your connection and try again.',
  emptyBrands: 'No brands found.',
  brandIdLabel: 'Brand ID:',
} as const;
